import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'fi',
  months: [
    'tammikuu',
    'helmikuu',
    'maaliskuu',
    'huhtikuu',
    'touko',
    'kesäkuu',
    'heinäkuu',
    'elokuu',
    'syyskuu',
    'lokakuu',
    'marraskuu',
    'joulukuu',
  ],
  monthsShort: [
    'tammi',
    'helmi',
    'maalis',
    'huhti',
    'toukokuu',
    'kesä',
    'heinä',
    'elo',
    'syys',
    'loka',
    'marras',
    'joulu',
  ],
  weekdays: ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'],
  weekdaysMin: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
  weekdaysShort: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd, D. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D. MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    lll: 'D. MMM YYYY HH:mm',
    'lll-Y': 'D. MMM HH:mm',
    llll: 'ddd, D. MMM YYYY HH:mm',
    'llll-Y': 'ddd, D. MMM HH:mm',
    'll-Y+w': 'ddd D. MMM',
    'LT+to': 'H.mm ([UTC]Z)',
    'LLL+to': 'D. MMMM YYYY H.mm ([UTC]Z)',
  },
  past: {
    y: { one: '%s v sitten', other: '%s v sitten' },
    M: { one: '%s kk sitten', other: '%s kk sitten' },
    w: { one: '%s vk sitten', other: '%s vk sitten' },
    d: { one: '%s pv sitten', other: '%s pv sitten' },
    h: { one: '%s t sitten', other: '%s t sitten' },
    m: { one: '%s min sitten', other: '%s min sitten' },
    s: { one: '%s s sitten', other: '%s s sitten' },
  },
  future: {
    y: { one: '%s v päästä', other: '%s v päästä' },
    M: { one: '%s kk päästä', other: '%s kk päästä' },
    w: { one: '%s vk päästä', other: '%s vk päästä' },
    d: { one: '%s pv päästä', other: '%s pv päästä' },
    h: { one: '%s t päästä', other: '%s t päästä' },
    m: { one: '%s min päästä', other: '%s min päästä' },
    s: { one: '%s s päästä', other: '%s s päästä' },
  },
  abbr: {
    y: { one: '%s v', other: '%s v' },
    M: { one: '%s kk', other: '%s kk' },
    w: { one: '%s vko', other: '%s vko' },
    d: { one: '%s pv', other: '%s pv' },
    h: { one: '%s t', other: '%s t' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  justNow: 'Juuri nyt',
  yesterday: 'Eilen',
  today: 'Tänään',
  tomorrow: 'Huomenna',
  weekStart: 1,
};
const localeName: LocaleName = 'fi';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
